<template lang="html">
  <div class="menuItemHead">
    <div class="menuItemTitle font-italic">
      <span v-if="labelId && labelId !== ''">{{ $t(labelId) }}</span>
      <span v-else>{{ label }}</span>
    </div>
    <div class="menuItemSubBar"/>
  </div>
</template>

<script>
export default {
  props: [
    /** Label to display */
    'label',
    /** i18n label ID used to display */
    'labelId'
  ],
  name: 'MobileMenuSectionHeader'
}
</script>

<style lang="css" scoped>
.menuItemHead {
  font-size: 16px;
  margin-bottom: 10px;
}
.menuItemTitle {
  color: #ddd;
}
.menuItemSubBar {
  width: 40px;
  height: 5px;
  margin-top: 8px;
  border-radius: 15%;
  background-color: var(--actionButtonColor);
}
</style>



// WEBPACK FOOTER //
// MobileMenuSectionHeader.vue?77641462